import * as React from "react";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError } from "components/actions";
import { Grid } from "components/controls/widget";
import DetailGrid, { DetailGridItem } from "common/components/controls/DetailGrid";
import Loading from "common/components/controls/Loading";
import Error from "common/components/controls/Error";
import * as API from "common/api/Evidence/Clenove/DetailClena";
import { formatDate } from "common/utils/FmtDate";
import PageContent from "common/web/PageContent";

interface State {
    loading: boolean;
    hasError: boolean;
    error?: string;
    licence?: API.Licence;
}


interface LicenceProps {
    clenId: number;
    idtClena: number;
}


type PropsType = LicenceProps & State & ActionsExecutorPropsType;


const initialState: State = {
    loading: true,
    hasError: false,
}

class Licence extends React.PureComponent<PropsType> {

    load = () => {
        const { executeAction, updateState, clenId, idtClena } = this.props;
        const action = API.GetLicenceOp(clenId)
            .onSuccess(d => {
                updateState({ loading: false, licence: d });
            })
            .onError(e => {
                const errMessage = e.errorData && e.errorData.notFound ? `Licence OP člena(ky) s IDT ${idtClena} nebyly nalezeny` : e.message;
                updateState({ loading: false, hasError: true, error: errMessage });
            });

        executeAction(action, { loading: true, hasError: false });
    }

    componentWillMount() {
        this.load();
    }

    render() {

        const { loading, hasError, error, licence } = this.props;

        const getItems = () => {
            const items: DetailGridItem[] = [
                { label: 'Evidované licence', content: <EvidovaneLicence seznam={licence.Funkce} /> },
                { divider: true },
                { label: 'Platné licence', content: <PlatneLicence seznam={licence.Funkce.filter(x => x.Platna)} /> },
                { divider: true },
                { label: 'Obory lektorské činnosti', content: <LektorskeObory seznam={licence.LektorskeObory} /> },
            ];

            return items;
        }

        return <PageContent titles={['Údaje odborného pracovníka', 'Licence']}>
            {loading
                ? <Loading loading={loading} color="primary" />
                : hasError
                    ? <Error>{error}</Error>
                    : <DetailGrid items={getItems()} />}
        </PageContent>
    }
}

export default withActionsExecutor<LicenceProps, State>(initialState, Licence);




interface EvidovaneLicenceProps {
    seznam: API.EvopLicence[];
}

class EvidovaneLicence extends React.Component<EvidovaneLicenceProps> {
    render() {
        const { seznam } = this.props;

        return seznam.length === 0
            ? <em>{'nejsou'}</em>
            : <Grid container direction="column" spacing={8} justify="space-between">
                {seznam.map((z, k) => <Grid key={k} item>{z.Nazev + ' - do ' + formatDate(z.DoData)}</Grid>)}
            </Grid>
    }
}



interface PlatneLicenceProps {
    seznam: API.EvopLicence[];
}

class PlatneLicence extends React.Component<PlatneLicenceProps> {
    render() {
        const { seznam } = this.props;

        return seznam.length === 0
            ? <em>{'nejsou'}</em>
            : <Grid container direction="column" spacing={8} justify="space-between">
                {seznam.map((z, k) => <Grid key={k} item>{z.Nazev}</Grid>)}
            </Grid>
    }
}



interface LektorskeOboryProps {
    seznam: API.EvopLektorObor[];
}

class LektorskeObory extends React.Component<LektorskeOboryProps> {
    render() {
        const { seznam } = this.props;

        return seznam.length === 0
            ? <em>{'nejsou'}</em>
            : <Grid container direction="column" spacing={8} justify="space-between">
                {seznam.map((z, k) => <Grid key={k} item>{z.Nazev}</Grid>)}
            </Grid>
    }
}
